import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/agent/";

export async function getAgentStatus() {
  try {
    const res = await axios.get(API_URL + "status", { headers: authHeader() });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function getAgentLogs(n = 200) {
  try {
    const res = await axios.get(API_URL + "logs", {
      params: { n },
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}
